import { lazy, Suspense, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
// These stylesheets also style the placeholder of every input, so they stay in the main
// stylesheet, in their old order, while the pages themselves load on demand.
import "./styles/registration.css";
import "./styles/login.css";
import "./styles/restore.css";
import "./styles/activation.css";
import Logout from "./components/auth/Logout";
import { Comparison } from "./components/Comparison";
import { Modal } from "./components/forms/Modal";
import { CalendarApp } from "./components/calendar/App/CalendarApp";
import { ThematicsList } from "./components/calendar/Thematics";
import { WindowLayer } from "./components/utility/FloatingWindow";
import Grid from "./components/calendar/GridLayout/Grid";

// The sign-in pages bring formik and yup, which the calendar doesn't need.
const Registration = lazy(() => import("./components/auth/Registration"));
const Login = lazy(() => import("./components/auth/Login"));
const RestorePassword = lazy(() => import("./components/auth/RestorePassword"));
const ActivateAccount = lazy(() => import("./components/auth/ActivateAccount"));

function App() {
    const auth = useSelector(state => state.auth);
    // Where windows outside the day's modal are drawn, such as the event form of the day view.
    const [windowLayer, setWindowLayer] = useState(null);
    return (
        <div className="App">
            <Modal />
            <WindowLayer value={windowLayer}>
                <Suspense fallback={null}>
                    <Routes>
                        <Route path="/" element={auth.isAuthenticated ? <CalendarApp /> : <Navigate to={'/login'} />} />
                        <Route path="/registration" element={<Registration />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/restore" element={<RestorePassword />} />
                        <Route path="/activate" element={<ActivateAccount />} />
                        <Route path="/comparison" element={<Comparison />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/thematics" element={auth.isAuthenticated ? <ThematicsList /> : <Navigate to={'/login'} />} />
                        <Route path="/test" element={<Grid />} />
                    </Routes>
                </Suspense>
            </WindowLayer>
            <div className="window-layer" ref={setWindowLayer} />
        </div>
    );
}

export default App;
